import { render, staticRenderFns } from "./FPW.vue?vue&type=template&id=2f0b6af6&"
import script from "./FPW.vue?vue&type=script&lang=js&"
export * from "./FPW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports